import { Component, OnInit, HostListener } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs/Observable';

import { FormErrors } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';
import { WarmUpService } from 'app/services/warmup/warmup.service';

import { TaskService } from 'app/task/task.service';
import { Task } from 'app/shared/models/task.model';
import { UserService } from 'app/admin/users/user.service';
import { User } from 'app/shared/models/user.model';

@Component({
  selector: 'delegatetask',
  templateUrl: './delegate-task.component.html'
})

/**
 * Dialog component to update task description through editor.
 */
export class DelegateTaskComponent implements OnInit {

  delegateTaskForm: FormGroup;
  users: Array<User>;
  taskData: Task;
  entityId: number;
  assignee: User;
  savingTask: boolean;
  filteredUsers: Observable<User[]>;

  formErrors = {
    'assigneeUserId': ''
  };

  validationMessages = {
    'assigneeUserId': {
      'required': 'Required field value.'
    }
  };

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private snackBarService: SnackBarService,
    private userService: UserService,
    private taskService: TaskService,
    private trackingService: TrackingService,
    private warmUpService: WarmUpService) { }

  ngOnInit() {
    this.buildForm();
    this.getUserList();
    this.setAssignee();
  }

  buildForm() {
    this.delegateTaskForm = this.formBuilder.group({
      assignee: ['', Validators.required]
    });
    this.delegateTaskForm.valueChanges.subscribe(data => this.onValueChanged(data));
  }

  onValueChanged(data?: any) {
    if (!this.delegateTaskForm) {
      return;
    }
    FormErrors('delegateTaskForm', this);
  }

  /*
  * Setting assigneeName form control can use a separate function because assignee
  * can be the displayName or (if displayName is null) the loginId
  */
  setAssignee(): void {
    this.filteredUsers = this.delegateTaskForm.get('assignee').valueChanges
      .startWith(null)
      .map(user => user && typeof user === 'object' ? user.name : user)
      .map(name => name ? this.filterUsers(name) : (this.users ? this.users.slice() : this.users));
  }

  filterUsers(val: string): User[] {
    return val ? this.users.filter(s => (s.name.toLowerCase().indexOf(val.toLowerCase()) === 0)) : this.users;
  }

  getUserList() {
    this.users = this.warmUpService.getUsersList();
    if (this.taskData && this.users) {
      this.assignee = this.users.find(user => user.loginId === this.taskData.assignee);
      this.delegateTaskForm.get('assignee').setValue(this.assignee);
    }
  }

  onSubmit({ value, valid }): void {
    this.savingTask = true;

    // Copy task to submit mutation, to prevent errors
    const mutateTask = {
      id: this.taskData.id,
      assignee: value.assignee.loginId
    };

    this.taskService.delegateTask(mutateTask)
      .subscribe(
      success => {
        this.savingTask = false;
        if (success.flagResult) {
          this.dialogRef.close(success);
        }
        this.trackingService
          .emitEvent(
          TrackingConstants.TASK_MANAGEMENT,
          TrackingConstants.PERFORM_UPDATE_TASK,
          TrackingConstants.SUCCESS, 1);
        this.callSnackBarService(success);
      },
      err => {
        this.savingTask = false;
        this.trackingService
          .emitEvent(
          TrackingConstants.TASK_MANAGEMENT,
          TrackingConstants.PERFORM_UPDATE_TASK,
          TrackingConstants.FAILURE, 0);
        this.callSnackBarService(err);
      }
    );
  }

  callSnackBarService(response: any) {
    this.snackBarService.showStatus(response,
      MessageService.TASK_UPDATED_SUCCESS,
      MessageService.TASK_UPDATED_FAILURE);
  }

  displayFn(user: User): string {
    return user ? user.name : '';
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    unsavedFormCheck(event, this.dialogRef, this.delegateTaskForm);
  }
}



// WEBPACK FOOTER //
// ./src/app/task/delegatetask/delegate-task.component.ts